import { render, staticRenderFns } from "./ProveedorValoracionesDialog.vue?vue&type=template&id=8cf07788"
import script from "./ProveedorValoracionesDialog.vue?vue&type=script&lang=js"
export * from "./ProveedorValoracionesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports